module.exports = __webpack_public_path__ + "static/media/scope-bg.1e0dd673.svg";